import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { Button } from "../../components/button";
import { H1 } from "../../components/h1";
import { Input } from "../../components/input";
import { acceptInvite } from "../../services/auth";
import { useLocale } from "../../stores/locale";

export function ControlInviteAccept() {
  const { locale, currentLanguage } = useLocale();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(password.length >= 8 && token.length > 0);
  }, [password, token]);

  if (!token) {
    return (
      <div className="mx-auto flex w-full max-w-xl flex-col gap-3">
        <H1>{locale.auth.inviteAcceptTitle}</H1>
        <p className="text-red-500">{locale.auth.inviteAcceptError}</p>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="mx-auto flex w-full max-w-xl flex-col gap-3">
        <H1>{locale.auth.inviteAcceptTitle}</H1>
        <p>{locale.auth.inviteAcceptSuccess}</p>
        <Link className="text-blue-700 hover:underline" to="/login">
          {locale.auth.backToLogin}
        </Link>
      </div>
    );
  }

  return (
    <form
      className="mx-auto flex w-full max-w-xl flex-col gap-3"
      onSubmit={(e) => {
        (async () => {
          e.preventDefault();
          setIsLoading(true);
          setHasError(false);
          try {
            await acceptInvite(token, password, currentLanguage);
            setIsSubmitted(true);
          } catch {
            setHasError(true);
          } finally {
            setIsLoading(false);
          }
        })();
      }}
    >
      <H1>{locale.auth.inviteAcceptTitle}</H1>
      <Input
        disabled={isLoading}
        hasError={hasError}
        placeholder={locale.login.password}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className="mt-2 flex items-center justify-end gap-2">
        {hasError && (
          <p className="text-red-500">{locale.auth.inviteAcceptError}</p>
        )}
        <Button disabled={!isValid || isLoading} type="submit">
          {locale.auth.inviteAcceptSubmit}
        </Button>
      </div>
    </form>
  );
}
